import { rankItems } from "@/mocks/guaData";
import type { RankItem } from "@/mocks/guaData";

const rankMedal = ["bg-primary-500 text-background-50", "bg-secondary-500 text-background-50", "bg-accent-500 text-background-50"];

const trendIcon: Record<RankItem["trend"], string> = {
  up: "ri-arrow-up-line text-primary-500",
  down: "ri-arrow-down-line text-secondary-500",
  flat: "ri-subtract-line text-foreground-400",
  new: "ri-sparkling-line text-accent-600",
};

function heatWidth(id: number) {
  const max = rankItems[0].heat;
  return `${Math.max(30, Math.round((rankItems.find((r) => r.id === id)?.heat || 0) / max) * 100)}%`;
}

export default function RankPanel() {
  return (
    <section id="rank" className="py-12 md:py-16">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 md:px-6 lg:grid-cols-[1.2fr_0.8fr]">
        <div>
          <div className="flex items-center justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-accent-600">
                <i className="ri-trophy-line"></i>
                热议榜单
              </p>
              <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                大家都在围观什么
              </h2>
            </div>
            <span className="hidden rounded-full border border-background-200 bg-background-50 px-3 py-1 text-xs text-foreground-500 sm:inline-flex">
              每 10 分钟刷新
            </span>
          </div>

          <ol className="mt-6 divide-y divide-background-100 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            {rankItems.map((r) => (
              <li key={r.id} className="flex items-center gap-4 px-4 py-3 transition hover:bg-primary-50/50">
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-display text-sm ${
                    r.id <= 3 ? rankMedal[r.id - 1] : "bg-background-100 text-foreground-500"
                  }`}
                >
                  {r.id}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate font-medium text-foreground-900">{r.title}</h3>
                    <i className={`${trendIcon[r.trend]} shrink-0`}></i>
                  </div>
                  <p className="truncate text-xs text-foreground-500">{r.desc}</p>
                </div>
                <div className="hidden w-24 sm:block">
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-100">
                    <div className="h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-400" style={{ width: heatWidth(r.id) }}></div>
                  </div>
                </div>
                <span className="shrink-0 whitespace-nowrap rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">{r.tag}</span>
              </li>
            ))}
          </ol>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-xl border border-background-200 bg-gradient-to-b from-accent-50 to-background-50 p-6">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-questionnaire-line text-lg"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">大家怎么看？</h3>
            </div>
            <p className="mt-3 text-sm text-foreground-600">
              每日投票：今晚恋综大结局你站哪一对？说出你的理由，看看有多少人和你同频。
            </p>
            <div className="mt-4 space-y-2.5 text-sm">
              {["坚定站队，等结果打脸", "谁赢都行，我就看个热闹", "围观组，纯来学评论话术"].map((o, i) => (
                <label
                  key={o}
                  className="flex cursor-pointer items-center gap-2.5 rounded-lg border border-background-200 bg-background-50 px-3 py-2.5 transition hover:border-accent-300"
                >
                  <input type="radio" name="poll" defaultChecked={i === 0} className="h-4 w-4 accent-primary-600" />
                  <span className="text-foreground-700">{o}</span>
                </label>
              ))}
            </div>
            <button className="mt-4 w-full whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-accent-600">
              提交我的看法
            </button>
            <p className="mt-3 text-center text-xs text-foreground-500">已有 1.2 万人参与</p>
          </div>

          <div className="rounded-xl border border-background-200 bg-background-50 p-6">
            <h3 className="font-heading text-base font-bold text-foreground-950">吃瓜小贴士</h3>
            <ul className="mt-3 space-y-2.5 text-sm text-foreground-600">
              <li className="flex gap-2"><i className="ri-discuss-line text-primary-500"></i><span>理性吃瓜，先看全貌再发言。</span></li>
              <li className="flex gap-2"><i className="ri-heart-line text-primary-500"></i><span>友善讨论，不造谣、不引战。</span></li>
              <li className="flex gap-2"><i className="ri-time-line text-primary-500"></i><span>热门更新快，错峰食用体验更佳。</span></li>
            </ul>
          </div>
        </aside>
      </div>
    </section>
  );
}